import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotes: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNotes"><Path d="M3 12H5M9.5 12H12.5M9.5 8.5H14.5M3 8.5H5M3 15.5H5M4.0625 3H20V21H4.0625V3Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconNotes;
